import React, { useState, useContext } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { Context as RestaurantContext } from '../../../context/restaurant';
import { useCurrency } from '../../../hooks/useCurrency';
import { timeStringFromMillis } from '../../../utils/dateHelpers';

const OrderPayments = ({ payments }) => {
  const { currencySymbol } = useCurrency();
  const { t } = useTranslation();

  const { state: restaurantState } = useContext(RestaurantContext);

  const [visible, setVisible] = useState(false);

  if (!payments || payments.length === 0) {
    return null;
  }

  const getStatusText = (status) => {
    if (status === 'Paid') {
      return t('order.alreadyPaid');
    }

    return '-';
  };

  const renderPaymentItem = (payment) => {
    return (
      <div
        key={payment.id}
        className="flex items-center justify-between text-bland font-primaryMedium text-sm mt-1"
      >
        <div className="flex items-center">
          <div className="w-12 mr-2">
            {timeStringFromMillis(payment.paidOn, restaurantState.restaurant.timeZone)}
          </div>
          <div>{getStatusText(payment.status)}</div>
        </div>
        <div>
          {(payment.amount || 0).toFixed(2)} {currencySymbol}
        </div>
      </div>
    );
  };

  return (
    <div className="mt-1">
      <button
        type="button"
        onClick={() => setVisible((prev) => !prev)}
        className="font-primaryMedium text-sm text-primary"
      >
        {t('buttons.moreInformation')}{' '}
        {visible ? (
          <MdKeyboardArrowUp className="inline" />
        ) : (
          <MdKeyboardArrowDown className="inline" />
        )}
      </button>
      {visible && payments.map(renderPaymentItem)}
    </div>
  );
};

export default OrderPayments;
